import styled from 'styled-components';

export const StyledContainer = styled.section`
  display:grid;
  width:100%;
  margin:0 auto;
  gap:20px;
  grid-template-columns:minmax(0, 1fr) minmax(300px, 32%);
  grid-template-areas:"heading heading" "controls players" "pitch players" "fixtures players";
  align-items:start;
  @media (max-width:1199px) { grid-template-columns:minmax(0,1fr); grid-template-areas:"heading" "controls" "pitch" "players" "fixtures"; gap:12px; }
  @media (min-width:1200px) {
    max-width:none;
    gap:12px;
    grid-template-columns:minmax(210px,260px) calc(var(--pitch-height,480px) * 1.18) minmax(390px,1fr);
    grid-template-areas:"heading heading heading" "controls pitch players" "controls fixtures players";
    grid-template-rows:auto var(--pitch-height, 480px) auto;
    align-items:stretch;
  }
`;

export const StyledAdsContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  @media only screen and (min-width: 1200px) {
    width: 1310px;
  }
  @media only screen and (max-width: 991px) {
    max-height: 200px;
  }
`;
